import React, { useEffect, useState } from "react";
import axios from "axios";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from "chart.js";
import AspirasiBerandaSkeleton from "../../../../Components/loading/skeletonBeranda";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
const FaUser = require("react-icons/fa").FaUser;
const FaUserTie = require("react-icons/fa6").FaUserTie;
const FaUserCog = require("react-icons/fa").FaUserCog;

ChartJS.register(ArcElement, Tooltip, Legend);

const UserAdmin = () => {
  const [summary, setSummary] = useState({
    total_users: 0,
    total_admins: 0,
    total_presidens: 0,
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/summary`);
      setSummary(res.data);
    } catch (err) {
      console.error("Gagal fetch summary:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  if (loading)
    return (
      <div>
        <AspirasiBerandaSkeleton />
      </div>
    );

  // data chart
  const data = {
    labels: ["User", "Staff", "Pejabat"],
    datasets: [
      {
        data: [summary.total_users, summary.total_admins, summary.total_presidens],
        backgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"],
        hoverOffset: 6,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
    },
  };

  const handleNavigateUser = () => {
    navigate(`/dashboard/pengguna`);
  };
  const handleNavigateAdmin = () => {
    navigate(`/dashboard/akun`);
  };
  const handleNavigatePejabat = () => {
    navigate(`/dashboard/pejabat`);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* --- Summary Cards --- */}
      <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Card Total Pengguna */}

        <div onClick={() => handleNavigateUser()} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between cursor-pointer hover:shadow-lg">
          <div className="w-full">
            <button className="bg-gray-100 p-4 rounded-lg mb-2">
              <FaUser className="w-6 h-6" />
            </button>
          </div>
          <h2 className="text-gray-600 text-start">Total User (Masyarakat)</h2>
          <p className="text-4xl font-bold text-start">{summary.total_users}</p>
        </div>

        {/* Card Total Staff */}

        <div onClick={() => handleNavigateAdmin()} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between cursor-pointer hover:shadow-lg">
          <div className="w-full">
            <button className="bg-gray-100 p-4 rounded-lg mb-2">
              <FaUserCog className="w-6 h-6" />
            </button>
          </div>
          <h2 className="text-gray-600 text-start">Total Admin Kementrian</h2>
          <p className="text-4xl font-bold text-start">{summary.total_admins}</p>
        </div>

        {/* Card Total Pejabat → Lebar Full */}
        <div onClick={() => handleNavigatePejabat()} className="bg-white p-6 rounded-lg shadow flex flex-col justify-between cursor-pointer hover:shadow-lg lg:col-span-2">
          <div className="w-full">
            <button className="bg-gray-100 p-4 rounded-lg mb-2">
              <FaUserTie className="w-6 h-6" />
            </button>
          </div>
          <div>
            <h2 className="text-gray-600 text-start">Total Pejabat</h2>
            <p className="text-gray-600 text-start text-xs">Presiden - Wakil Presiden, Mentri & Wakil Mentri, Serta Pejabat setingkat Mentri</p>
          </div>

          <p className="text-4xl font-bold text-start">{summary.total_presidens}</p>
        </div>
      </div>

      {/* --- Chart --- */}
      <div className="bg-white p-6 rounded-lg shadow flex flex-col items-center">
        <h2 className="text-lg font-bold mb-4">Presentase Data</h2>
        <div className="w-full max-w-xs">
          <Doughnut data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default UserAdmin;
